module.exports = __webpack_public_path__ + "img/icon-wifi.7643fc03.svg";